import { Loadable } from 'foundations-components/transitional/utils/Loadable';
const loadBoardSettingsProvider = () => import( /* webpackChunkName: "crm-object-board-settings" */'crm-object-board/crmObjectPropertyBoard/BoardSettingsProvider').then(mod => mod.BoardSettingsProvider);
export const AsyncBoardSettingsProvider = Loadable({
  loader: loadBoardSettingsProvider,
  LoadingComponent: () => null,
  ErrorComponent: () => null
});